module.exports = __webpack_public_path__ + "media/images/ofn-o-c798da87128493a32d9c29fbb9ebefe7.png";